import { PropsWithChildren } from "react";
import { ReactQueryProvider } from "@providers/react-query-provider.tsx";
import { HouseholdInformationProvider } from "@providers/household-information-provider.tsx";
import { WhiteLabelProvider } from "@providers/white-label-provider.tsx";

type RootProvidersProps = PropsWithChildren;

export const DataProviders = ({ children }: RootProvidersProps) => {
  return (
    <ReactQueryProvider>
      <WhiteLabelProvider>
        <HouseholdInformationProvider>{children}</HouseholdInformationProvider>
      </WhiteLabelProvider>
    </ReactQueryProvider>
  );
};
